import React from 'react';
import Alert, { AlertColor } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

/* Inline page message (replaces Semantic <Message>) */
const Notice: React.FC<{ title?: string; severity?: AlertColor }> = ({ title, severity = 'info', children }) => (
    <Alert severity={severity} variant="outlined" sx={{ borderRadius: 2, backgroundColor: severity === 'info' ? '#EAF2FF' : undefined }}>
        {title && <AlertTitle sx={{ fontWeight: 600, mb: children ? 0.25 : 0 }}>{title}</AlertTitle>}
        {children}
    </Alert>
);

export default Notice;
